var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.596 20H5.404a.892.892 0 01-.904-.88V4.88c0-.486.405-.88.904-.88h14.192c.5 0 .904.394.904.88v14.24c0 .486-.405.88-.904.88z",
    stroke: "#222",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.803 7.76h5.393M17.173 7.782h3.064M4.768 7.782h3.064",
    stroke: "#222",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.212 9.158h-.615a.539.539 0 01-.546-.532V6.893a.54.54 0 01.546-.531h.615a.54.54 0 01.547.53v1.734a.539.539 0 01-.547.532zM16.403 9.158h-.615a.539.539 0 01-.547-.532V6.893a.54.54 0 01.547-.531h.615a.54.54 0 01.546.53v1.734a.539.539 0 01-.546.532zM6.957 17.534h11.086v-6.49H6.957v6.49z",
    stroke: "#222",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.672 11.191v6.196M14.328 11.191v6.196M17.968 14.289H7.03",
    stroke: "#222",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.10523ee8.svg";
export { ForwardRef as ReactComponent };